import { applicationTypeConstants } from "@/utils/enum/ApplicationTypeConstants";
import { storageConstants } from "@/utils/enum/StorageConstants";

const init = () => {
  const initExcludes = getExcludeKeys();
  deleteStoryWithoutArray(initExcludes);
  localStorage.setItem(
    storageConstants.applicationType,
    applicationTypeConstants.learner
  );
};

const deleteStoryWithoutArray = initExcludes => {
  for (let storageKey in localStorage) {
    if (!initExcludes.includes(storageKey)) {
      localStorage.removeItem(storageKey);
    }
  }
};

const getExcludeKeys = () => {
  let initExcludes = [
    storageConstants.vueAppApiHost,
    storageConstants.vueAppPaymentHost,
    storageConstants.naverKey,
    storageConstants.telegramBot,
    storageConstants.telegramUrl,
    storageConstants.rememberUser,
    storageConstants.skillPathAuth,
    storageConstants.idpSignOutUrl,
    storageConstants.idpService,
    storageConstants.idpServiceUrl,
    storageConstants.redirectPath,
    storageConstants.dynamicQuery,
  ];

  return languageInfoPushOrSplice(initExcludes);
};

const languageInfoPushOrSplice = initExcludes => {
  if (isApplicationTypeEqualsLearner()) {
    initExcludes.push(storageConstants.languageInfo);
  } else {
    let index = initExcludes.indexOf(storageConstants.languageInfo);
    if (index > -1) {
      initExcludes.splice(index, 1);
    }
  }
  return initExcludes;
};

const isApplicationTypeEqualsLearner = () => {
  return (
    localStorage.getItem(storageConstants.applicationType) ===
    applicationTypeConstants.learner
  );
};

const getLanguageInfo = () => {
  return localStorage.getItem(storageConstants.languageInfo);
}

const getBgColor = () => {
  return localStorage.getItem(storageConstants.bgColors);
}

const setToken = (token) => {
  return localStorage.setItem(storageConstants.token, token);
}

const getToken = () => {
  return localStorage.getItem(storageConstants.token);
}

const getIdpUrl = () => {
  const idpServiceUrl = getIdpServiceUrl();
  return idpServiceUrl.idpUrl;
}

const getIdpServiceUrl = ()=> {
  let idpServiceUrl = localStorage.getItem(storageConstants.idpServiceUrl);
  return JSON.parse(idpServiceUrl);
}

const getUdemyUrl = () => {
  const idpServiceUrl = getIdpServiceUrl();
  return idpServiceUrl.udemyUrl;
}

const isIdpServiceValidate = () => {
  return JSON.parse(localStorage.getItem(storageConstants.idpService));
}

const getIdpSignOutUrl = () => {
  return localStorage.getItem(storageConstants.idpSignOutUrl);
}

const isSkillPath = () => {
  const skillPath = localStorage.getItem(storageConstants.skillPathAuth);
  if (!skillPath) {
    return false;
  }
  const array = skillPath.split(',');
  return array.includes(localStorage.getItem(storageConstants.brandCode));
}

const getUTCTime = () => {
  return JSON.parse(localStorage.getItem(storageConstants.UTCTime));
}

const setUTCTime = (time) => {
  return localStorage.setItem(storageConstants.UTCTime, JSON.stringify(time));
}

let localStorageUtil = {
  init,
  getLanguageInfo,
  getBgColor,
  getToken,
  setToken,
  getIdpUrl,
  getUdemyUrl,
  isIdpServiceValidate,
  getIdpSignOutUrl,
  isSkillPath,
  getIdpServiceUrl,
  getUTCTime,
  setUTCTime
};
export default localStorageUtil;
